export default {
  personal: 'Uso pessoal',
  autonomous: 'Autônomo',
  mei: 'MEI',
  enterprise: 'Corporativo',
  labels: {
    company_name: 'Razão Social',
    full_name: 'Nome completo',
  },
  options: {
    person: {
      personal: 'Uso pessoal',
      autonomous: 'Autônomo',
      mei: 'MEI',
      enterprise: 'Empresa'
    },
    gender: {
      M: 'Masculino',
      F: 'Feminino'
    }
  },
  legends: {
    registrationType: 'Tipo de cadastro',
    dataCompany: 'Dados da Empresa',
    dataResponsible: 'Dados do Responsável'
  },
  title: 'Crie sua conta'
}
